<template>
    <div class="card mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <router-link :to="{name: 'organization.addData'}" v-if="$store.state.role == 'organization' || $store.state.role == 'tourismorg'" class="btn btn-info ml-2">افزودن عکس و متن دلخواه</router-link>
            <router-link :to="{name: 'organization.addData'}" v-else class="btn btn-info ml-2">افزودن عکس دلخواه</router-link>
            <hr>
            <nav class="nav nav-tabs mb-3" v-if="$store.state.role == 'organization' || $store.state.role == 'tourismorg'">
                <a class="nav-link ml-1 active" data-toggle="tab" href="#photos">تصاویر</a>
                <a class="nav-link" data-toggle="tab" href="#texts">متن ها</a>
            </nav>
            <div class="tab-content">
                <div class="tab-pane active show" id="photos">
                    <div class="row" v-if="imagesList.length">
                        <div class="col-md-2 mb-3 text-center" v-for="image in imagesList" :key="image.mediaId">
                            <div class="thun-img-parent mb-3">
                                <img :src="`https://cardapi.sabinarya.com/${image.picUrl}`">
                            </div>
                            <p class="mt-3 mb-2" style="font-size: 21px" v-if="image.isApproved == 1"><i class="text-success fe fe-check"></i></p>
                            <p class="mt-3 mb-2" style="font-size: 21px" v-if="image.isApproved == 0"><i class="text-danger fe fe-x"></i></p>
                            <p class="mt-3 mb-2" style="font-size: 21px" v-if="image.isApproved == 2 || image.isApproved == 3"><i class="text-primary ti-timer"></i></p>
                            <p v-if="image.isApproved == 0 && image.mediaLogs.length && image.mediaLogs[0].description">علت عدم تایید : {{ image.mediaLogs[0].description }}</p>
                        </div>
                    </div>
                    <div class="alert alert-info mb-0" v-else>
                        <p class="mb-0">تصویری یافت نشد</p>
                    </div>
                </div>
                <div class="tab-pane" id="texts">
                    <table class="table table-bordered table-hover" v-if="textsList.length">
                        <thead>
                            <tr>
                                <th>متن</th>
                                <th>وضعیت</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="text in textsList" :key="text.mediaId">
                                <td>{{ text.text }}</td>
                                <td :class="'mt-3 ' + (text.isApproved == 1 ? 'text-success' : (text.isApproved == 2 ? 'text-primary' : 'text-danger'))">{{ text.isApproved == 1 ? 'تایید شده' : (text.isApproved == 2 ? 'در انتظار تایید' : 'رد شده') }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="alert alert-info mb-0" v-else>
                        <p class="mb-0">متنی یافت نشد</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'AddData',
    data(){
        return {
            showLoading: false,
            imagesList: [],
            textsList: []
        }
    },
    methods: {
        getData(){
            this.$api.get('Organizations/Media?ApprovedOnly=false&Option=2&Global=false').then(({data}) => {
                if(data.status && data.result.length){
                    this.imagesList = data.result.filter(image => image.metadataKeyId == 2);
                    this.textsList = data.result.filter(text => text.metadataKeyId == 3);
                }
            });
        }
    },
    created(){
        this.getData();
    }
}
</script>